import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_app_shop = `${hostApi}/api/app/shops`;
const api_shop_business = `${hostApi}/api/shopBusiness`;

function getShopBusiness(params) {
    return Vue.prototype.$http.get(`${api_shop_business}/time`, { params });
}

function getShopList(params) {
    return Vue.prototype.$http.get(api_app_shop, { params });
}

function getShop(id) {
    return Vue.prototype.$http.get(`${api_app_shop}/${id}`);
}

export {
    getShopBusiness,
    getShopList,
    getShop,
};
